module.exports = __webpack_public_path__ + "img/twix.d5280129.jpg";